<template>
    <v-container fluid grid-list-xl class="pt-0">
        <v-layout align-center wrap>
            <v-flex pt-0>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                            <v-icon>fa fa-eye</v-icon>
                            Detalles del Estudiante
                        </v-toolbar-title>
                        <v-divider class="mx-2" inset vertical></v-divider>

                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn icon @click="printEstudiante">
                                <v-icon>fa-print</v-icon>
                            </v-btn>
                            <v-btn icon @click="cancelForm()">
                                <v-icon>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-container fluid grid-list-xl class="px-1 py-1">
                            <v-layout align-center wrap>
                                <v-flex xs12 sm2 pr-0 pl-4 style="max-width: 174px">
                                    <v-avatar size="150">
                                        <v-img
                                            :src="detailsItem.imagen ? detailsItem.imagen : require('@/images/avatar.png')"
                                        ></v-img>
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs12 sm4 pl-0>
                                    <h4 class="headline mb-2 mt-1 text-xs-center">
                                        {{
                                            detailsItem.nombre +
                                                " " +
                                                detailsItem.apellido_paterno +
                                                " " +
                                                detailsItem.apellido_materno
                                        }}
                                    </h4>
                                    <div class="blue--text text-xs-center mb-1">
                                        Mátricula: {{ detailsItem.matricula }}
                                    </div>
                                    <div
                                        :class="
                                            detailsItem.estado === 0
                                                ? 'grey--text text-xs-center mb-2'
                                                : 'success--text text-xs-center mb-2'
                                        "
                                    >
                                        {{ detailsItem.status_description ? detailsItem.status_description : "-" }}
                                    </div>
                                    <div class="text-xs-center pt-3">
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="orange"
                                            :disabled="loading"
                                            @click="openForm(detailsItem)"
                                        >
                                            Editar
                                        </v-btn>
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="orange"
                                            :disabled="loading"
                                            @click="deleteItem(detailsItem)"
                                        >
                                            {{ deleteEstudianteConfirm ? "Confirmar" : "Eliminar" }}
                                        </v-btn>
                                    </div>
                                </v-flex>

                                <v-flex sm6>
                                    <v-container fluid grid-list-xl class="px-1 py-0">
                                        <v-layout align-center wrap>
                                            <v-divider inset vertical></v-divider>
                                            <v-layout tag="v-card-text" text-xs-left wrap>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Fecha nacimiento:</v-flex>
                                                <v-flex sm5>{{ detailsItem.fecha_nacido }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Sexo:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.sexo ? detailsItem.sexo.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Peso:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.peso ? detailsItem.peso + " Kg" : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Estatura:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.estatura ? detailsItem.estatura + " cm" : "-"
                                                }}</v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12 pt-1>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 py-1">
                                        <v-layout align-center wrap>
                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fecha de alta:</v-flex
                                                            >
                                                            <v-flex sm5>{{ detailsItem.fecha_alta }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fecha de baja:</v-flex
                                                            >
                                                            <v-flex sm5>{{ detailsItem.fecha_baja }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Escuela de procedencia:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.escuela_procedencia
                                                                    ? detailsItem.escuela_procedencia
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Domicilio:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.domicilio ? detailsItem.domicilio : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Transporte escolar:</v-flex
                                                            >
                                                            <v-flex
                                                                sm5
                                                                v-if="detailsItem.tipo_transporte_escolar === 4"
                                                                >{{ detailsItem.tipo_transporte_escolar_otro }}</v-flex
                                                            >
                                                            <v-flex sm5 v-else>{{
                                                                detailsItem.tipo_transporte_escolar
                                                                    ? transporte_escolar[
                                                                          detailsItem.tipo_transporte_escolar - 1
                                                                      ]
                                                                    : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Padre:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.padre
                                                                    ? detailsItem.padre.nombre +
                                                                      " " +
                                                                      detailsItem.padre.apellido_paterno +
                                                                      " " +
                                                                      detailsItem.padre.apellido_materno
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Madre:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.madre
                                                                    ? detailsItem.madre.nombre +
                                                                      " " +
                                                                      detailsItem.madre.apellido_paterno +
                                                                      " " +
                                                                      detailsItem.madre.apellido_materno
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Convive con:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.convive_con !== null
                                                                    ? convive_con[detailsItem.convive_con]
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Cantidad de hermanos:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.cantidad_hermanos
                                                                    ? detailsItem.cantidad_hermanos
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Cantidad de habitantes:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.cantidad_habitantes
                                                                    ? detailsItem.cantidad_habitantes + " personas"
                                                                    : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Estado nutrición:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.estado_nutricional
                                                                    ? estado_nutricional[
                                                                          detailsItem.estado_nutricional - 1
                                                                      ]
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Tipo de sangre:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.tipo_sangre
                                                                    ? detailsItem.tipo_sangre.nombre
                                                                    : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Servicio médico:</v-flex
                                                            >
                                                            <v-flex sm5
                                                                >{{
                                                                    detailsItem.servicio_medico
                                                                        ? detailsItem.servicio_medico.nombre
                                                                        : "-"
                                                                }}
                                                            </v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Agudeza visual:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.agudeza_visual
                                                                    ? agudeza_visual[detailsItem.agudeza_visual - 1]
                                                                    : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12 pt-1>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 pt-1 pb-3">
                                        <v-layout align-center wrap>
                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Alergias:</v-flex
                                                            >
                                                            <v-flex sm5
                                                                >{{ !detailsItem.alergias ? "-" : "" }}
                                                                <template v-if="detailsItem.alergias">
                                                                    <span
                                                                        :key="alergia"
                                                                        v-for="(alergia, index) in getItemsArray(
                                                                            detailsItem.alergias
                                                                        )"
                                                                    >
                                                                        <br v-if="index !== 0" />
                                                                        {{ alergia }}
                                                                    </span>
                                                                </template>
                                                            </v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Padecimientos:</v-flex
                                                            >
                                                            <v-flex sm5
                                                                >{{ !detailsItem.padecimientos ? "-" : "" }}
                                                                <template v-if="detailsItem.padecimientos">
                                                                    <span
                                                                        :key="padecimiento"
                                                                        v-for="(padecimiento, index) in getItemsArray(
                                                                            detailsItem.padecimientos
                                                                        )"
                                                                    >
                                                                        <br v-if="index !== 0" />
                                                                        {{ padecimiento }}
                                                                    </span>
                                                                </template>
                                                            </v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Medicamentos:</v-flex
                                                            >
                                                            <v-flex sm5
                                                                >{{ !detailsItem.medicamentos ? "-" : "" }}
                                                                <template v-if="detailsItem.medicamentos">
                                                                    <span
                                                                        :key="medicamento"
                                                                        v-for="(medicamento, index) in getItemsArray(
                                                                            detailsItem.medicamentos
                                                                        )"
                                                                    >
                                                                        <br v-if="index !== 0" />
                                                                        {{ medicamento }}
                                                                    </span>
                                                                </template>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm12 text-xs-center mr-2
                                                                >Documentos entregados:</v-flex
                                                            >
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Acta de nacimiento:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                getItemValue(detailsItem.ractanacido)
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Carta de buena conducta:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rcarta_buena_conducta === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Carta de no adeudo:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rcarta_no_adeudo === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Certificado de primaria:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                getItemValue(detailsItem.rcertificado_primaria)
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Boleta primer año:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                getItemValue(detailsItem.rboleta_primer_anyo)
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Boleta segundo año:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                getItemValue(detailsItem.rboleta_segundo_anyo)
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Constancia examen:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                getItemValue(detailsItem.rconstancia_examen)
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm12 text-xs-center mr-2
                                                                >Documentos entregados:</v-flex
                                                            >
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Examen médico:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rexamen_medico === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>CURP:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.rcurp === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Contrato:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rcontrato === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Aviso de privacidad:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.raviso_privacidad === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Ficha de inscripción:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rfecha_inscripcion === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Reglamento:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rreglamento === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Hoja de informes:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.rhoja_informes === 1 ? "si" : "No"
                                                            }}</v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <estudiante-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </estudiante-form>

        <print-estudiante-template
            v-show="false"
            :estudiante-object="detailsItem"
            id="printEstudiante"
        ></print-estudiante-template>
    </v-container>
</template>

<script>
const PrintEstudianteTemplate = () => import("@/views/cobranza/estudiante/print-estudiante-template")
const EstudianteForm = () => import("@/components/cobranza/estudiante/estudiante-form")
export default {
    name: "EstudianteDetails",
    components: { PrintEstudianteTemplate, EstudianteForm },
    props: {
        item: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,

            servicio_medico: ["IMSS", "ISSSTE", "PEMEX", "Otro"],
            convive_con: ["Sin padres", "Madre", "Padre", "Madre y Padre"],
            estado_nutricional: ["Nutrición normal", "Desnutrición moderada", "Desnutrición severa"],
            agudeza_visual: ["Normal", "Disminuída", "Usa lentes"],
            transporte_escolar: ["Transporte escolar", "Vienen por él", "Se va solo"],

            title: "",
            showForm: false,
            editItem: null,

            deleteEstudianteConfirm: false
        }
    },
    methods: {
        cancelForm() {
            this.$emit("detailsCanceled")
        },

        getEdad() {
            let fnacido = this.detailsItem.fecha_nacido.split("/")[2]
            let today = new Date()
                .toISOString()
                .substr(0, 10)
                .split("-")[0]
            return today - fnacido
        },

        getItemsArray(string) {
            return string.split(",")
        },

        openForm(item) {
            this.title = "Modificar estudiante"
            this.editItem = item
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(item) {
            if (this.deleteEstudianteConfirm) {
                this.loading = true
                this.$store.dispatch("DELETE_ESTUDIANTE", item).then(() => {
                    this.loading = false
                    this.$emit("detailsCanceled")
                    this.deleteEstudianteConfirm = false
                })
            } else {
                this.deleteEstudianteConfirm = true
            }
        },

        getItemValue(value) {
            switch (value) {
                case 1:
                    return "No"
                case 2:
                    return "Original"
                case 3:
                    return "Copia"
                default:
                    return "Valor incorrecto"
            }
        },

        printEstudiante() {
            this.$htmlToPaper("printEstudiante")
        }
    },

    computed: {
        detailsItem() {
            return this.$store.getters.ESTUDIANTES.filter(el => el.id === this.item.id)[0]
        }
    }
}
</script>

<style scoped></style>
